<template>
    <div class="popup-container" :class="theme">
        <h2>
            {{ title }}
        </h2>
        <p class="event-tag">{{ subtitle }}</p>
        <p class="event-tag2">{{ subtitle2 }}</p>
        <div class="time-container">
            <div class="days">
                <h3>{{ remainingDays }}</h3>
                <p>DAYS</p>
            </div>
            <div class="hours">
                <h3>{{ remainingHours }}</h3>
                <p>HOURS</p>
            </div>
            <div class="minutes">
                <h3>{{ remainingMinutes }}</h3>
                <p>MINS</p>
            </div>
        </div>
        <a href="#" @click.prevent="handleCTAClick()">
            {{ ctaText }}
        </a>
        <div class="img-blk" @click="handleClose()">
            <img src="@/assets/icon-cancel.svg" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.popup-container {
    width: size(216);
    height: size(308);
    padding: size(30) size(30) size(30) size(30);
    position: fixed;
    left: size(30);
    box-shadow: 12px 12px 25px 0px rgba(0, 0, 0, 0.28);
    border-radius: size(12);
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    animation: slideup 1s ease-in-out;
    animation-fill-mode: forwards;
    transition: bottom 0.3s ease;
    z-index: var(--slidein-z-index);

    &.bbl-theme {
        background-image: url('../assets/bbl-pop-up.png');
        background-repeat: no-repeat;
        background-color: #221F20;
        background-size: 100% auto;
        background-position: center;
        background-size: contain;

    }

    @keyframes slideup {
        0% {
            bottom: size(-200);
        }

        100% {
            bottom: size(20);
        }
    }

    h2 {
        padding: 0;
        color: #B4E372;
        font-size: 24px;
        font-style: normal;
        font-weight: 800;
        line-height: 30px;
        font-family: var(--rz-para-font);

        span {
            display: block;
        }
    }

    .event-tag {
        font-size: size(16);
        font-weight: 400;
        font-family: var(--rz-para-font);
        color: #fff;
        margin-top: size(8);
        line-height: size(22);
    }
    .event-tag2 {
        font-size: size(14);
        font-weight: 400;
        font-family: var(--rz-para-font);
        color: #A9A8A8;;
        margin-top: size(24);
        line-height: size(15.4);
    }

    .time-container {
        display: flex;
        margin-top: size(14);
        margin-bottom: size(60);

        >div {
            display: flex;
            flex-direction: column;
            text-align: center;

            h3 {
                color: #A588FF;
                font-size: size(34);
                font-weight: 600;
                line-height: size(42.5);
                animation: pulse 2s ease-in-out infinite;
            }

            p {
                color: #EAEAEA;
                font-size: size(10);
                font-weight: 600;
                line-height: size(15);
                font-family: var(--rz-para-font);
            }
        }

        .days {
            padding-right: 14px;
        }
        .hours {
            padding-right: 14px;
            padding-left: 14px;
        }
        .minutes {
            padding-left: 14px;
            padding-right: 14px;
        }

    }

    @keyframes pulse {

        0%,
        100% {
            transform: scale(1);
        }

        50% {
            transform: scale(1.05);
        }
    }

    a {
        padding: size(10) size(18);
        color: var(--rs-black-color);
        border-radius: size(4);
        background: #FFF;
        width: size(88);
        cursor: pointer;
        font-size: size(12);
        font-family: var(--rz-para-font);
        font-weight: 500;
        line-height: size(14);
        transition: all 0.3s ease;
        text-decoration: none;
        display: inline-block;

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }

        &:active {
            transform: translateY(0);
        }
    }

    .img-blk {
        position: absolute;
        top: size(12);
        right: size(12);
        cursor: pointer;
        padding: size(4);
        border-radius: size(4);
        transition: all 0.2s ease;

        &:hover {
            background: rgba(255, 255, 255, 0.1);
            transform: scale(1.1);
        }

        img {
            display: block;
            width: size(20);
            height: size(20);
        }
    }

}
</style>

<script>
import moment from 'moment';

export default {
  name: 'CountDownPopup',
  props: {
    endDate: {
      type: String,
      default: '2025-12-14T23:59:59',
    },
    title: {
      type: String,
      default: 'Big Bash League 2025 - 26',
    },
    subtitle: {
      type: String,
      default: 'is right around the corner!',
    },
    subtitle2: {
      type: String,
      default: 'Countdown to Glory',
    },
    ctaText: {
      type: String,
      default: 'Join the action',
    },
    theme: {
      type: String,
      default: 'bbl-theme',
    },
    redirectUrl: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      countdownEnd: moment.utc(this.endDate),
      remainingDays: 0,
      remainingHours: 0,
      remainingMinutes: 0,
      remainingSeconds: 0,
      countdownInterval: null,
    };
  },
  mounted() {
    // Validate end date
    if (!moment(this.endDate).isValid()) {
      console.error('CountdownPopup: Invalid end date provided');
      this.hidePopup();
      return;
    }
    // future date?
    if (moment.utc().isSameOrAfter(this.countdownEnd)) {
      console.log('CountdownPopup: End date has already passed');
      this.hidePopup();
      return;
    }

    this.getCountdown();
    this.countdownInterval = setInterval(() => {
      this.getCountdown();
    }, 1000);
  },
  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  },
  methods: {
    formatNumber(num) {
      return num < 10 ? `0${num}` : num;
    },
    getCountdown() {
      const now = moment.utc();
      if (now.isSameOrAfter(this.countdownEnd)) {
        this.hidePopup();
        return;
      }
      const totalDiff = this.countdownEnd.diff(now);
      const days = Math.floor(totalDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((totalDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((totalDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((totalDiff % (1000 * 60)) / 1000);

      this.remainingDays = this.formatNumber(days);
      this.remainingHours = this.formatNumber(hours);
      this.remainingMinutes = this.formatNumber(minutes);
      this.remainingSeconds = this.formatNumber(seconds);
    },
    handleCTAClick() {
      if (this.redirectUrl) {
        this.hidePopup();
        window.location.href = this.redirectUrl;
      } else {
        this.$emit('ctaClicked');
      }
    },
    handleClose() {
      this.hidePopup();
    },
    hidePopup() {
      this.$emit('hidePromo', false);
    },
  },
};
</script>
